import list from './list';
import create from './create';
import update from './update';
import show from './show'
import del from './delete';
import agreementList from './agreement-list';
import documentList from './document-list';

export default {
  namespaced: true,
  modules: {
    list,
    create,
    update,
    show,
    del,
    agreementList,
    documentList
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/customer/index.js